module.exports = __webpack_public_path__ + "img/cqfw3.9fbbe8b1.png";